import { ModulesConfig } from '@eui/core';

export const MODULES: ModulesConfig = {
    core: {
        api: {
            base: '/rasff-window/backend',
            user: {
                details: '/user-details',
                preferences: '',
                rights: '/user-rights',
            },
        },
    },
};
